import { Button, Tooltip } from "@mantine/core";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setNMEAModalData } from "src/redux/slices/generatorFeaturesSlice";
import { isOnline } from "src/utils/isOnline";

const ReopenNMEAModalButton = () => {
  const dispatch = useDispatch();
  const { lbentry } = useSelector(s => s.generatorSlice);

  const handleOpen = () => {
    dispatch(setNMEAModalData({ opened: true }));
  };

  if (!lbentry.NMEA || !isOnline()) return null;

  const hasNMEAData =
    !!lbentry.NMEAData &&
    Object.values(lbentry.NMEAData).some(v => v.rows.length > 0);

  return (
    <Tooltip
      label="No NMEA Data available to view"
      position="top"
      withArrow
      disabled={!!hasNMEAData}>
      <Button ml={15} onClick={handleOpen}>
        View NMEA Data
      </Button>
    </Tooltip>
  );
};
export default ReopenNMEAModalButton;
